import { TeamsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useTeamsAPI(): TeamsApi {
  return new TeamsApi(apiConfig);
}
